import React from 'react'
import { Text } from '..'
import styles from './Sentence.module.css'

export const Sentence = React.memo(({text, signature}) => (
    <div className={`absolute flex-column z-index-50 ${styles.sentence}`}>
        <Text className={styles.text} dangerouslySetInnerHTML={{ __html: text }} />
        <Text className={styles.signature}>{ signature }</Text>
    </div>
))